var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"protokoll-datum"},[_c('strong',[_vm._v("Datum*")]),_c('StatusDate',{attrs:{"form-label-class":"d-none"},model:{value:(_vm.datum),callback:function ($$v) {_vm.datum=$$v},expression:"datum"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }